const host =process.env.REACT_APP_API_BASE_URL;
//bot & bot flow
export const startApi = `${host}/start`;
export const fetchAllBot = `${host}/getAllBots`;
export const saveBot =`${host}/savebot`;
export const get_bots = `${host}/fetchBots`;
export const getbotflow = `${host}/botflow`;
export const publishChnls = `${host}/bots/publish`;
export const saveBotFlow = `${host}/savebotflow`;
export const deleteBot = `${host}/deletebot`;
export const answerApi = `${host}/answer`;
export const fetcBotQuestions = `${host}/getAllBotQuestion`
export const langTranslatePost = `${host}/languageConfigTranslate`
export const Generalconfig =`${host}/general`
export const getAllLanguage = `${host}/getAllLanguage`
export const fetchgeneral = `${host}/fetchgeneral`
//auth
export const loginUser = `${host}/auth/login`;
export const create_users = `${host}/auth/register`;
//user
export const delete_users = `${host}/users/delete`;
export const update_users = `${host}/users/updateUser`;
export const fetchAll_users = `${host}/users/userManagement`;
export const fetch_roles = `${host}/users/fetchRoles`;
export const fetchadminSuppArray = `${host}/users/roles`;
export const fetchrolesbyusers = `${host}/users/fetch_menus_based_roles`
//channels
export const channelDetails = `${host}/channels/channelDetails`;
export const createChannel = `${host}/channels/createchannel`;
export const fetchChannels=`${host}/channels/fetchchannel`;
export const updateChannel = `${host}/channels/updatechannel`;
export const deleteChannel = `${host}/channels/deletechannel`;
//chat_users
export const chatGetAllocatedUsers =`${host}/chatusers/fetchUnallocatedChatusers`;
export const chatGetUsers =`${host}/chatusers/fetchChatusers`;
export const fetchChatUsers=`${host}/chatusers/findChatByUser`;
export const sendMsg=`${host}/chatusers/postChatusers`;
export const updateChatUsersCount=`${host}/chatusers/updateChatreaders`;
export const getbotbyHistsession = `${host}/chatusers/botChatHistorybySesssion`
export const updaterequestUnallocate = `${host}/chatusers/updaterequest`;
export const getliveSupportByExternal = `${host}/chatusers/getliveSupportByExternal`;
export const updatelivesupportflag = `${host}/chatusers/updatelivesupportflag`;
export const updateProfileDetls= `${host}/users/userUpdateprofile`
export const fetchUsersProfile = `${host}/users/fetchUserprofile`

//history_router
export const fetchHistoryByMobileNo = `${host}/historychat/takeHistoryByNumber`
//republish live bots
export const republishbots = `${host}/bots/republish`
export const stopBots = `${host}/bots/stop`
export const startBots =`${host}/bots/start`
export const deleteBots=`${host}/bots/delete`

//translator
export const translator=`${host}/translate/translator`